<template>
  <form>
      <div class="row q-col-gutter-md">
          <div class="col col-xs-12 col-md-4 col-lg-4">
              <q-input
                  v-model="CurrencyObj.name"
                  :label="$t('currencies.table_titles.name')"
                  lazy-rules
                  :error="CurrencyObj.errors.has('name')"
                  :error-message="CurrencyObj.errors.get('name')"
                  :rules="[ val => val && val.length > 0 || 'The Currency name is required!']"
                  color="primary"
                  hint="Ex: Bitcoin"
              />
          </div> <!-- NAME -->
          <div class="col col-xs-12 col-md-4 col-lg-4">
              <q-input
                  v-model="CurrencyObj.acronym"
                  :label="$t('currencies.table_titles.acronym')"
                  lazy-rules
                  :error="CurrencyObj.errors.has('acronym')"
                  :error-message="CurrencyObj.errors.get('acronym')"
                  :rules="[ val => val && val.length > 0 || 'The Currency acronym is required!']"
                  color="primary"
                  hint="Ex: BTC"
                  :readonly="editMode"
              />
          </div> <!-- ACRONYM -->
          <div class="col col-xs-12 col-md-4 col-lg-4">
              <q-input
                  v-model="CurrencyObj.symbol"
                  :label="$t('currencies.table_titles.symbol')"
                  :error="CurrencyObj.errors.has('symbol')"
                  :error-message="CurrencyObj.errors.get('symbol')"
                  input-class="text-center"
                  color="primary"
                  hint="Ex: ฿ | BTC"
              />
          </div> <!-- SYMBOL -->
          <div class="col col-xs-12 col-md-4 col-lg-4">
              <q-input
                  v-model="CurrencyObj.decimals"
                  :label="$t('currencies.table_titles.decimals')"
                  :error="CurrencyObj.errors.has('decimals')"
                  :error-message="CurrencyObj.errors.get('decimals')"
                  input-class="text-center"
                  color="primary"
              />
          </div> <!-- DECIMALS -->
          <div class="col col-xs-12 col-md-4 col-lg-4">
              <q-input
                  v-model="CurrencyObj.matchmaking_threshold"
                  :label="$t('currencies.table_titles.matchmaking_threshold')"
                  :error="CurrencyObj.errors.has('matchmaking_threshold')"
                  :error-message="CurrencyObj.errors.get('matchmaking_threshold')"
                  input-class="text-center"
                  color="primary"
              />
          </div> <!-- MATCHMAKING THRESHOLD -->
          <div class="col col-xs-12 col-sm-6 col-md-4">
              <p class="text-caption q-pb-xs" style="margin:0">Currency Type</p>
              <q-toggle
                  v-model="CurrencyObj.is_fiat"
                  color="primary"
                  :label="CurrencyObj.is_fiat ? 'Fiat' : 'Crypto'"
                  checked-icon="fa fa-dollar-sign"
                  unchecked-icon="fab fa-bitcoin"
                  keep-color
              />
          </div> <!-- IS FIAT -->
      </div>
    </form>
</template>

<script>
export default {
  name: 'Form',
  model: {
    prop: 'CurrencyObj',
    event: 'change'
  },
  props: {
    CurrencyObj: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  data() {
    return {
      loading: false
    }
  },
  methods: {
    submit() {
      this.$emit('submit')
    },
  },
  created() {},
  components: {},
}
</script>

<style scoped>

</style>
